import * as React from "react";
import { StakeHolder } from "../StakeHolder";
import { Dropdown } from "../Dropdown";
export class StakeType extends React.Component {
    render() {
        return (this.props.isFreeBetView
            ? React.createElement(Dropdown, { data: this.props.freebetData, selectItem: this.props.dropdownHandler, blockName: "pulse-bet", defaultText: this.props.defaultText })
            : React.createElement(StakeHolder, { data: this.props.stakeData }));
    }
}
//# sourceMappingURL=StakeType.js.map